import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { environment } from "../../../../../environments/environment";
import { Controle } from "../../models/controle.model";
import { ControlePod } from "../../models/controle-pod.model";
import { Checklist } from "../../../list/models/checklist.model";
import { ElementTypeControle } from "../../enums/element-type-controle";

@Injectable({ providedIn: "root" })
export class ControleApiService implements EntityApiService<Controle> {
  httpClient = inject(HttpClient);

  loadOne(id: string): Observable<Controle> {
    throw new Error("Method not implemented.");
  }

  answer(entity: Controle): Observable<Controle> {
    return this.httpClient.post<Controle>(
      `${environment.api()}/controle/answer`,
      entity,
    );
  }

  answerForChecklist(
    entity: Controle,
    checklistId: string,
  ): Observable<{ controle: Controle; checklist: Checklist }> {
    return this.httpClient.post<{ controle: Controle; checklist: Checklist }>(
      `${environment.api()}/checklist/answer/controle/${checklistId}`,
      entity,
    );
  }

  create(entity: Controle): Observable<Controle> {
    return this.httpClient.post<Controle>(
      `${environment.api()}/controle`,
      entity,
    );
  }

  remove(id: string): Observable<string> {
    return this.httpClient.delete<string>(
      `${environment.api()}/controle/${id}`,
    );
  }

  update(entity: Controle): Observable<Controle> {
    return this.httpClient.post<Controle>(
      `${environment.api()}/controle`,
      entity,
    );
  }

  loadAll(): Observable<Controle[]> {
    throw new Error("Method not implemented.");
  }

  loadForPodId(podId: string): Observable<Controle[]> {
    return this.httpClient.get<Controle[]>(
      `${environment.api()}/controle/podId/${podId}`,
    );
  }

  loadForPodIds(podIds: string[]): Observable<Controle[]> {
    return this.httpClient.post<Controle[]>(
      `${environment.api()}/controle/podIds/`,
      { podIds },
    );
  }

  duplicate(entity: Controle): Observable<Controle> {
    return this.httpClient.post<Controle>(
      `${environment.api()}/controle/duplicate`,
      entity,
    );
  }

  saveAll(payload: { controles: Controle[] }) {
    return this.httpClient.post<Controle[]>(
      `${environment.api()}/controle/all`,
      payload,
    );
  }

  createPod() {
    return this.httpClient.post<ControlePod>(
      `${environment.api()}/controle_pod/create`,
      null,
    );
  }

  loadControlesGeneraux(elemType?: ElementTypeControle) {
    return this.httpClient.get<Controle[]>(
      `${environment.api()}/controle/general/${elemType}`,
    );
  }
}
